"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.invariant=function(e,r){if(!Boolean(e))throw new Error(null!=r?r:"Unexpected invariant triggered.")};
//# sourceMappingURL=invariant.mjs.js.map
